module.exports = __webpack_public_path__ + "img/remittance.035788fe.png";